export const incidentStatuses = {   
    COMPLETED: 0,
    OUTSTANDING: 1,    
    NA: 2,
    IN_PROGRESS: 3,
  };